export const INVENTORY_SIGN_POSITIVE_CLASS = "text-success";
export const INVENTORY_SIGN_NEGATIVE_CLASS = "text-danger";

export const getInventorySignClassName = (isPositive) =>
  isPositive ? INVENTORY_SIGN_POSITIVE_CLASS : INVENTORY_SIGN_NEGATIVE_CLASS;

export const INVENTORY_SIGN_POSITIVE_COLOR = "#198754";
export const INVENTORY_SIGN_NEGATIVE_COLOR = "#dc3545";

export const getInventorySignColor = (isPositive) =>
  isPositive ? INVENTORY_SIGN_POSITIVE_COLOR : INVENTORY_SIGN_NEGATIVE_COLOR;
